<div class="d-flex justify-content-between align-items-center header "
    [ngStyle]="{'border-bottom':'2px solid black', 'margin-bottom':'10px'}">
    <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Create Template</h2>
    <div class="d-flex align-items-center gap-3">
        <mat-icon (click)="close()" [ngStyle]="{'cursor':'pointer'}">close</mat-icon>
    </div>
</div>
<div id="gjs" class="p-4">
</div>
<div id="blocks"></div>

<!-- <div *ngIf="createTemplate">
<input type="text" placeholder="templateName"  matInput [(ngModel)]="templateName">
<mat-radio-group required aria-label="Select an option" [(ngModel)]="status">
    <mat-radio-button class="matButton"  value="Private" >Private</mat-radio-button>
    <mat-radio-button class="matButton"  value="Public">public</mat-radio-button>
    <mat-radio-button class="matButton"  value="Self">Self</mat-radio-button>
</mat-radio-group>
<button (click)="export()">Export</button>
</div> -->

<div class="flex-clss">
   <button mat-raised-button color="primary" class="button-container primary" *ngIf="!updateTemplate"
        (click)="saveTemplate()" [ngStyle]="{'margin':'2px'}">Save Template</button>
    <button mat-raised-button color="primary" class="button-container primary" *ngIf="updateTemplate" (click)="update()"
        [ngStyle]="{'margin':'2px'}">Update Template</button>
    <button mat-raised-button color="primary" class="button-container primary" (click)="editTemplate()"
        [ngStyle]="{'margin':'2px'}">Edit Template</button>
    <button mat-raised-button color="primary" class="button-container primary" (click)="blankTemplate()"
        [ngStyle]="{'margin':'2px'}">Reset</button>
</div>
<button id="visibility" (click)="loadInlineCss()" hidden="true">visibility</button>
